var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper flex-center bg-image"},[_c('h1',{staticClass:"text-white p-5"},[_vm._v("Welcome to Xnergy Dashboard")])])}]

export { render, staticRenderFns }